import {
  STICKY_ACTIONS_WIDTH,
  stickyActionColumnStyle,
} from "../../utils/gridTableUx";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

/**
 * Horizontal scrollbar strip for My Vendors / Vendor List tables.
 * Reserves the sticky Actions column width on the right so the track does not
 * run underneath the pinned kebab column (Innovation Lab parity).
 */
export default function MyVendorsStickyScrollbar({
  scrollRef,
  isScrollbarSticky = false,
}) {
  return (
    <div
      className={classNames(
        "flex w-full",
        isScrollbarSticky ? "sticky bottom-0 z-50" : "relative"
      )}
    >
      <div
        ref={scrollRef}
        className={classNames(
          "min-w-0 flex-1 overflow-x-auto overflow-y-hidden",
          isScrollbarSticky
            ? "border-t border-gray-300 bg-gray-50 shadow-lg"
            : "rounded-bl-xl border-t border-gray-200 bg-white"
        )}
        style={{ height: "12px", marginTop: 0, padding: 0 }}
      >
        <div
          className="sticky-scrollbar-inner bg-transparent"
          style={{ height: "1px", width: "100%", minWidth: "100%" }}
        />
      </div>
      <div
        aria-hidden
        className={classNames(
          "flex-none border-t",
          isScrollbarSticky
            ? "border-gray-300 bg-gray-50"
            : "rounded-br-xl border-gray-200 bg-white"
        )}
        style={{
          ...stickyActionColumnStyle(),
          height: "12px",
          width: STICKY_ACTIONS_WIDTH,
        }}
      />
    </div>
  );
}
